module.exports = __webpack_public_path__ + "media/images/dd-logo-nav-mobile-187eba75.svg";